import { createContext, useContext, useState } from 'react';

// Create the context
const BoardContext = createContext();

// Create a provider component
export const BoardProvider = ({ children }) => {
  const [bucketsExpandedState, setBucketsExpandedState] = useState({});

  const setBucketExpandedState = (bucketId, isExpanded) => {
    setBucketsExpandedState((prevBuckets) => ({
      ...prevBuckets,
      [bucketId]: {
        ...prevBuckets[bucketId],
        isExpanded
      }
    }));
  };

  const setGroupExpandedState = (bucketId, isExpanded, groupIndex = 0) => {
    setBucketsExpandedState((prevBuckets) => ({
      ...prevBuckets,
      [bucketId]: {
        ...prevBuckets[bucketId],
        groups: {
          ...prevBuckets[bucketId]?.groups,
          [groupIndex]: {
            ...prevBuckets[bucketId]?.groups?.[groupIndex],
            isExpanded
          }
        }
      }
    }));
  };

  const setGigExpandedState = (gigId, bucketId, isExpanded, groupIndex = 0) => {
    setBucketsExpandedState((prevBuckets) => ({
      ...prevBuckets,
      [bucketId]: {
        ...prevBuckets[bucketId],
        groups: {
          ...prevBuckets[bucketId]?.groups,
          [groupIndex]: {
            ...prevBuckets[bucketId]?.groups?.[groupIndex],
            gigs: {
              ...prevBuckets[bucketId]?.groups?.[groupIndex]?.gigs,
              [gigId]: {
                isExpanded
              }
            }
          }
        }
      }
    }));
  };

  return (
    <BoardContext.Provider
      value={{
        bucketsExpandedState,
        setBucketExpandedState,
        setGigExpandedState,
        setGroupExpandedState
      }}
    >
      {children}
    </BoardContext.Provider>
  );
};

// Create a hook to use the BoardContext
export const useBoardContext = () => {
  const context = useContext(BoardContext);
  if (!context) {
    throw new Error('useBoardContext must be used within a BoardProvider');
  }
  return context;
};
